import locale777d96b6 from '../../src/locales/it.js'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"it"},
  vueI18nLoader: false,
  locales: [{"code":"it","name":"🇮🇹 Italiano","iso":"it-IT","file":"it.js","dir":"ltr"},{"code":"en","name":"🇬🇧 English","iso":"en-US","file":"en.js","dir":"ltr"}],
  defaultLocale: "it",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "locales/",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieAge":365,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","redirectOn":"root","useCookie":true},
  differentDomains: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"it","name":"🇮🇹 Italiano","iso":"it-IT","file":"it.js","dir":"ltr"},{"code":"en","name":"🇬🇧 English","iso":"en-US","file":"en.js","dir":"ltr"}],
  localeCodes: ["it","en"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "\"",
  2: "i",
  3: "t",
  4: ".",
  5: "j",
  6: "s",
  7: "\"",
  8: ":",
  9: "\"",
  10: ".",
  11: ".",
  12: "/",
  13: "s",
  14: "r",
  15: "c",
  16: "/",
  17: "l",
  18: "o",
  19: "c",
  20: "a",
  21: "l",
  22: "e",
  23: "s",
  24: "/",
  25: "i",
  26: "t",
  27: ".",
  28: "j",
  29: "s",
  30: "\"",
  31: ",",
  32: "\"",
  33: "e",
  34: "n",
  35: ".",
  36: "j",
  37: "s",
  38: "\"",
  39: ":",
  40: "\"",
  41: ".",
  42: ".",
  43: "/",
  44: "s",
  45: "r",
  46: "c",
  47: "/",
  48: "l",
  49: "o",
  50: "c",
  51: "a",
  52: "l",
  53: "e",
  54: "s",
  55: "/",
  56: "e",
  57: "n",
  58: ".",
  59: "j",
  60: "s",
  61: "\"",
  62: "}",
}

export const localeMessages = {
  'it.js': () => Promise.resolve(locale777d96b6),
  'en.js': () => import('../../src/locales/en.js' /* webpackChunkName: "lang-en.js" */),
}
